"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MapCursorHelper_1 = require("../MapCursorHelper");
const onRoutingPointMouseEnter = (e) => {
    if (e.features && e.features[0]) {
        (0, MapCursorHelper_1.addHoverClass)();
    }
};
const onRoutingPointMouseLeave = (_e) => {
    (0, MapCursorHelper_1.removeHoverClass)();
};
const nodeLayerEventDescriptors = [
    { type: 'layer', layerName: 'routingPoints', eventName: 'mouseenter', handler: onRoutingPointMouseEnter },
    { type: 'layer', layerName: 'routingPoints', eventName: 'mouseleave', handler: onRoutingPointMouseLeave }
];
exports.default = nodeLayerEventDescriptors;
//# sourceMappingURL=RoutingLayerMapEvents.js.map